import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

const PAGE_ACCESS = tenantDashboardPath("/me/page-access");
const WORKSPACE_BOOTSTRAP = tenantDashboardPath("/me/workspace-bootstrap");

/** @returns {Promise<{ workspaceId: string, allowedPageKeys: string[] }>} */
export async function getMePageAccess() {
  return tenantApiFetch(PAGE_ACCESS);
}

/**
 * @returns {Promise<{ workspaceIds: string[], defaultWorkspaceId: string | null }>}
 */
export async function getWorkspaceBootstrap() {
  return tenantApiFetch(WORKSPACE_BOOTSTRAP);
}
